module.exports = __webpack_public_path__ + "9682339704fe6b857a100df039b5f2ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/sales_redisign.png
// module id = 476
// module chunks = 0